import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import shortid from 'shortid';

import version from '../../version.js';
import './ToolFooter.css';

import { toggleLights, setAutoSave, setRecentPatterns, setGridMode } from '../../actions/actions.export.js'
import Tabs from '../Tabs/Tabs.js'

import canI from '../../canI.js';

class ToolFooter extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  render(){
    const {nav, dispatch, globalReducer, patternManager, user, team} = this.props;

    return <div id="tool-footer">
      <div className="footer-group">
       
        {
          /*canI(user, team, 'recent_patterns', team.current) && <span>
            <Tabs
              items={[
                  {
                    display: <i className="fas fa-fw fa-lg fa-arrow-alt-to-left"/>,
                    value: false
                  },
                  {
                    display: <i className="fas fa-fw fa-lg fa-history"/>,
                    value: true
                  }
                ]}
              value={globalReducer.showRecentPatterns}
              size='small'
              onChange={(e) => { dispatch(setRecentPatterns(e.value)) }}
              />
            &nbsp;&nbsp;
          </span>*/
        }
        {
          canI(user, team, 'nightmode', team.current) && <span>
            <Tabs
            items={[
                {
                  display: <i className="fas fa-fw fa-lg fa-sun"/>,
                  value: true
                },
                {
                  display: <i className="fas fa-fw fa-lg fa-moon"/>,
                  value: false
                }
              ]}
            value={globalReducer.lights}
            size='small'
            onChange={(e)=>{dispatch(toggleLights(e.value))}}
            />&nbsp;&nbsp;
          </span>
        }
        {
          /*
          canI(user, team, 'custom_layouts', team.current) && 
          <Tabs
            items={[
                {
                  display: <i className="far fa-fw fa-lg fa-columns"/>,
                  value: 2
                },
                {
                  display: <i className="far fa-fw fa-lg fa-th-large"/>,
                  value: 4
                }
              ]}
            value={globalReducer.gridMode}
            size='small'
            onChange={(e)=>{dispatch(setGridMode(e.value))}}
            />
            */
        }
      </div>

      <div className="footer-group">
        <div className="footer-group-item footer-social-adjust footer-group-item-small-pad">
          <a className="no-underline" href="https://instagram.com/pattycakeio" target="_blank" rel="noopener noreferrer"><i className="fab fa-fw fa-instagram fa-lg"/></a>
        </div>
        <div className="footer-group-item footer-social-adjust footer-group-item-small-pad">
          <a  className="text-700" href="https://twitter.com/pattycakeio" target="_blank" rel="noopener noreferrer"><i className="fab fa-fw fa-twitter fa-lg"/></a>
        </div>
        <div className="footer-group-item">
          <a href={"https://twitter.com/messages/compose?recipient_id=1012554189761925125&text=I found a bug in Pattycake v" + version + (user.isLoggedIn ? (team.current ? "t" : (user.roles.pro ? "p" : "f")) : "a") + " ..."} target="_blank" className="text-300">
            Report a Bug
          </a>
        </div>
        <div className="footer-group-item">
          <a href="https://twitter.com/pattycakeio" target="_blank" rel="noopener noreferrer" className="text-700">
            v{version}{user.isLoggedIn ? (team.current ? "t" : (user.roles.pro ? "p" : "f")) : "a"}
          </a>
        </div>
        <div className="footer-group-item footer-cake-adjust">
          <img src="/img/pink-cake.png" height="20px"/>
        </div>
      </div>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { 
    nav, globalReducer, patternManager, user, team
    //...
  } = state;

  return {
    nav, globalReducer, patternManager, user, team
    //...
  }
}

export default connect(mapStateToProps)(ToolFooter);


// WEBPACK FOOTER //
// ./src/components/ToolFooter/ToolFooter.js